import { render, staticRenderFns } from "./ChooseCourse.vue?vue&type=template&id=bf3c16f0&scoped=true&"
import script from "./ChooseCourse.vue?vue&type=script&lang=js&"
export * from "./ChooseCourse.vue?vue&type=script&lang=js&"
import style0 from "./ChooseCourse.vue?vue&type=style&index=0&id=bf3c16f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3c16f0",
  null
  
)

export default component.exports